import { WNATIVE } from '../tokens'
import { Token, Currency, NativeCurrency } from '@uniswap/sdk-core'
import invariant from 'tiny-invariant'

export class Binance extends NativeCurrency {
  protected constructor(chainId: number) {
    super(chainId, 18, 'BNB', 'Binance Coin')
  }

  public get wrapped(): Token {
    const wnative = WNATIVE[this.chainId]
    invariant(!!wnative, 'WRAPPED')
    return wnative
  }

  private static _cache: { [chainId: number]: Binance } = {}

  public static onChain(chainId: number): Binance {
    return this._cache[chainId] ?? (this._cache[chainId] = new Binance(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}